.bookings__searchbox {
  margin-top: 2.5rem;
}
